import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser's automatic scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Clear any existing scroll restoration from session storage
    try {
      sessionStorage.removeItem('scrollPosition');
      sessionStorage.removeItem('scroll-position');
      localStorage.removeItem('scrollPosition');
      localStorage.removeItem('scroll-position');
    } catch (e) {
      // Ignore storage errors
    }

    // Scroll to top immediately and after a short delay to ensure it works
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Immediate scroll
    scrollToTop();

    // Backup scroll after DOM is fully ready
    const scrollTimer = setTimeout(() => {
      scrollToTop();
    }, 10);

    // Additional backup for slower systems
    const scrollTimer2 = setTimeout(() => {
      scrollToTop();
    }, 100);

    return () => {
      clearTimeout(scrollTimer);
      clearTimeout(scrollTimer2);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
